<kendo-daterange #daterange class="date-range-selection">
  <!-- Inputs -->
  <div class="date-range-selection__inputs">
    <kendo-dateinput
      kendoDateRangeStartInput
      autoCorrectOn="blur"
      [format]="DATE_FORMAT"
      [(value)]="value.start"
      [min]="min"
      [max]="max"
    ></kendo-dateinput>
    <span>&#8211;</span>
    <kendo-dateinput
      kendoDateRangeEndInput
      autoCorrectOn="blur"
      [format]="DATE_FORMAT"
      [(value)]="value.end"
      [min]="min"
      [max]="max"
    ></kendo-dateinput>
  </div>

  <!-- Popup -->
  <kendo-daterange-popup #popup 
  >
    <ng-template kendoDateRangePopupTemplate>
      <div class="date-range-selection__popup" #popupWrapper>
        <!-- List Periods -->
        <section class="date-range-selection__periods">
          <button
            class="btn btn-outline text-left date-range-selection__periods__option"
            [class.date-range-selection__periods__option--active]="period.value === value?.type"
            *ngFor="let period of DEFAULT_PERIODS"
            (click)="selectPeriod(period.value)">
            {{ period.label }}
          </button>
        </section>

        <section class="date-range-selection__controls">
          <kendo-multiviewcalendar
            [disabledDates]="disabledDates"
            [disabledDatesRangeValidation]="true"
            [todayButton]="false"
            kendoDateRangeSelection
          ></kendo-multiviewcalendar>

          <div
            class="date-range_selection__controls__actions d-flex justify-content-end"
          >
            <button type="button" class="btn btn-link" (click)="onCancel()">Cancel</button>
            <button
              [style.min-width.px]="70"
              type="button"
              class="btn btn-success ml-1"
              (click)="onApply()"
            >
              Save
            </button>
          </div>
        </section>
      </div>
    </ng-template>
  </kendo-daterange-popup>
</kendo-daterange>
